<div class="mantenimiento-container">

  <img src="assets/logos/jaguar_blanco.png" 
       alt="Mantenimiento" 
       class="logo-mantenimiento">

</div>